import { IVehicleTypes, IBasicMileageHistory } from "..";

export interface IBasicMileageRequestDto {
  orgId: string;
}


export class BasicMileageRequestDto implements IBasicMileageRequestDto {
  orgId: string;

  constructor(orgId: string) {
    this.orgId = orgId;
  }

}


export interface ISaveMileageRequestDto {
  orgId: string;
  createdBy: number;
  MileageUOM: number; 
  MileageUOMLabel: string;
  vehicleTypes: IVehicleTypes[];
  basicMileageHistory: IBasicMileageHistory[];
  action:number;
}


export class SaveMileageRequest implements ISaveMileageRequestDto {
  orgId: string;
  createdBy: number;
  MileageUOM: number;
  MileageUOMLabel: string;
  vehicleTypes: IVehicleTypes[];
  basicMileageHistory: IBasicMileageHistory[];
  action:number;

  //constructor(orgId: string,
  //  createdBy: number,
  //  MileageUOM: number,
  //  MileageUOMLabel: string,
  //  vehicleTypes: IVehicleTypes[],
  //  basicMileageHistory: IBasicMileageHistory[]) {
  //  this.MileageUOMLabel = MileageUOMLabel;
  //  this.createdBy = createdBy;
  //  this.MileageUOM = MileageUOM;
  //  this.vehicleTypes = vehicleTypes;
  //  this.basicMileageHistory = basicMileageHistory;
  //}
}


